import React from "react";
import { cn } from "@/components/common/utils";

interface CarouselRightGradientProps {
  isVisible: boolean;
  className?: string;
  color?: string;
}

export default function CarouselRightGradient({
  isVisible,
  className,
  color = "#ffffff",
}: CarouselRightGradientProps) {
  return (
    <div
      className={cn(
        "h-full w-[50px] md:w-[100px] z-10 absolute right-0 transition-opacity duration-500",
        isVisible ? "opacity-100" : "opacity-0",
        className
      )}
      style={{
        backgroundImage: `linear-gradient(to left, ${color}, transparent)`,
      }}
    />
  );
}
